module.exports = __webpack_public_path__ + "img/speaking-pattern.f90cb0e6.jpg";